import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-terms',
    templateUrl: './terms.component.html',
    styleUrls: ['./terms.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TermsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
